import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import NotFoundArt from '../components/NotFoundArt'

/**
 * Shown both for routes that do not exist and for routes the signed-in user is
 * not allowed to see.
 *
 * The same page serves both on purpose. Telling someone "this exists but you
 * may not see it" confirms the existence of admin tooling to a user who has no
 * business knowing about it; "not found" reveals nothing. The message differs
 * only enough to be honest about what to do next.
 */
export default function NotFound({ reason = 'missing' }) {
  const { t } = useTranslation()
  return (
    <div className="notfound">
      <NotFoundArt />
      <h1 className="notfound-title">{t('not_found.title')}</h1>
      <p className="notfound-body">
        {reason === 'forbidden' ? t('not_found.forbidden') : t('not_found.missing')}
      </p>
      <Link to="/" className="btn btn-primary">{t('not_found.home')}</Link>
    </div>
  )
}
